module.exports = __webpack_public_path__ + "img/kategoria_sprawycodzienne.3f3dbce7.jpg";